import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useService from '@hooks/useService'

import type { ServiceModel } from '@models/types'

const ServiceListItem = (props: { service: ServiceModel }) => {
  const { service } = props
  const { id, title } = service

  const useServicePayload = useService(service)
  const { callbacks: { editService } } = useServicePayload

  return (
    <DashboardModuleListItem
      onClick={() => editService()}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ServiceListItem
